<div class="row">
  <div class="col-8 offset-2">
    <div class="modal-body">
      <div class="row mb-2">
        <button class="btn btn-success mb-1 mr-2" (click)="toPDF()">
          Generar PDF
        </button>
        <!-- <button class="btn btn-success mb-1" (click)="test()">test</button> -->
        <div
          class="col col-md-6 px-0 input-group"
          *ngIf="!!expediente && !!venta"
        >
          <div
            class="input-group-prepend"
            *ngIf="venta.estado_venta != 'cerrada'"
          >
            <span class="input-group-text"> Formato</span>
          </div>
          <select
            *ngIf="venta.estado_venta != 'cerrada'"
            (change)="select_change()"
            class="form-control"
            name="id_plantilla"
            [(ngModel)]="expediente.id_plantilla"
          >
            <option value="Sin formato" (click)="seleccion_plantilla(-1)">
              Sin formato
            </option>
            <option
              value="{{ item.id }}"
              (click)="seleccion_plantilla(idx)"
              *ngFor="let item of politicas; let idx = index"
            >
              {{ item.nombre }}
            </option>
            <option value="Personalizado" (click)="seleccion_plantilla(-2)">
              Personalizado
            </option>
          </select>
          <div *ngIf="!!expediente && !!venta">
            <button
              *ngIf="venta.estado_venta != 'cerrada'"
              class="btn btn-primary mb-1 mr-2"
              (click)="guardar_formato()"
            >
              Guardar Formato
            </button>
          </div>
        </div>
      </div>
    
      <!-- ========== Start pdf ========== -->
      <div class="container">
        <div class="pdf_header pdf_header_balance">
          <table>
            <tr>
              <!-- logo -->
              <td>
                <img
                  src="https://sistema.tadeoviajesyturismo.com/assets/img/tadeoLogo.png"
                  alt="logo"
                  height="90"
                />
              </td>
              <!-- info genera -->
              <td class="text-center">
                <h1>TADEO VIAJES Y TURISMO</h1>
                <h3>VIAJA CON NOSOTROS</h3>
                <p><b>Tel.-4773322772, 4772269080 y 4776885789</b></p>
                <p>
                  JUAN JOSE TORRES LANDA No. 1701 29 Col. LOMAS DE LA PISCINA
                </p>
                <!-- <p><b>tadeoviajesyturismo@hotmail.com</b></p> -->
                <!-- agente nombre telefono y correo -->
                <p *ngIf="!!agente">
                  <b>Agente: </b
                  ><span>{{ agente.nombre }} {{ agente.apellidos }}</span>
                  <b>Correo: </b><span>{{ agente.email }}</span> <b>Tel.: </b
                  ><span>
                    <i
                      class="fa fa-whatsapp text-success"
                      aria-hidden="true"
                    ></i>
                    {{ agente.movil }}</span
                  >
                </p>
              </td>
              <!-- info documento -->
              <td>
                <table
                  class="text-center table-bordered"
                  *ngIf="!!venta && !!expediente"
                >
                  <tr>
                    <td>Balance</td>
                  </tr>
                  <tr>
                    <td>Venta {{ venta.id }}</td>
                  </tr>
                  <tr>
                    <td>Fecha venta</td>
                  </tr>
                  <tr>
                    <td>{{ venta.fecha_venta | date: "dd/MM/yyyy" }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <table *ngIf="!!expediente">
            <tr>
              <th>Cliente: {{ expediente.nombre_cliente }}</th>
            </tr>
          </table>
        </div>
        <div class="pdf_container pdf_body_balance">
          <div class="pdf_body">
            <!-- tabla principal -->
            <table style="overflow: wrap">
              <thead>
                <tr>
                  <th>Concepto</th>
                  <th>Descripción</th>
                  <th>Fechas</th>
                  <th>Boleto</th>
                  <th>Clave</th>
                </tr>
              </thead>
    
              <tbody *ngFor="let _partida of partidas; let idx = index">
                <tr
                  *ngFor="
                    let item of _partida.descripcion.split('\n');
                    let indx = index
                  "
                >
                  <td *ngIf="indx == 0">
                    {{ _partida.nombre_concepto_venta }}
                  </td>
                  <td *ngIf="indx > 0" colspan="1"></td>
                  <td class="description">
                    <p>
                      <!-- <br *ngIf="!item" /> -->
                      {{ item }}
                    </p>
                  </td>
    
                  <td *ngIf="indx == 0">
                    {{ _partida.fecha_inicio | date: "dd/MM/yyyy" }}
                    {{ _partida.fecha_fin | date: "dd/MM/yyyy" }}
                  </td>
                  <td *ngIf="indx == 0">{{ _partida.boleto }}</td>
                  <td *ngIf="indx == 0">{{ _partida.reserva }}</td>
                  <td *ngIf="indx > 0" colspan="3"></td>
                </tr>
                <tr *ngIf="idx == partidas.length - 1">
                  <td colspan="1"></td>
                  <td class="descripcion">
                    <p
                      contenteditable="true"
                      id="plantilla_selected_content"
                      *ngIf="!!plantilla_selected"
                      [innerHTML]="plantilla_convert_to_html()"
                    ></p>
                  </td>
                  <td colspan="3"></td>
                </tr>
              </tbody>
            </table>
    
            <!-- Relacion pagos -->
            <table *ngIf="pagos_clientes.length > 0" style="overflow: wrap">
              <tr>
                <td><b>Relación pagos</b></td>
                <td
                  colspan="5"
                  class="text-right"
                  *ngIf="!!venta && pagos_clientes.length > 0"
                >
                  Total venta MXN: {{ venta.total_venta | currency }}
                  <small>{{ venta.clave_divisa }}</small>
                </td>
              </tr>
              <tr class="border-bottom">
                <td>Fecha</td>
                <td>Recibo</td>
                <td>Forma de Pago</td>
                <td>Pago</td>
                <td>Notas</td>
                <td></td>
              </tr>
              <tr>
                <td colspan="6"><hr /></td>
              </tr>
              <tr *ngFor="let item of pagos_clientes; let idx = index">
                <td>
                  {{ item.fecha_pago | date: "dd/MM/yyyy" }}
                  {{ item.hora_pago }}
                </td>
                <td>{{ item.id }}</td>
                <td>{{ item.nombre_forma_pago }}</td>
                <td>{{ item.monto | currency }}</td>
                <td colspan="2">
                  {{ item.notas }} {{ item.monto | currency }}
                </td>
              </tr>
              <tr class="text-right">
                <td colspan="3">Total pago:</td>
                <td colspan="2" class="text-left">
                  <p>
                    {{ venta.pagado_cliente | currency }}
                    {{ venta.clave_divisa }}
                  </p>
                </td>
                <td *ngIf="venta.total_venta - venta.pagado_cliente == 0">
                  <b>Pagado</b>
                </td>
                <td *ngIf="venta.total_venta - venta.pagado_cliente > 0">
                  Total Saldo:
                  <b>
                    {{ venta.total_venta - venta.pagado_cliente | currency }}
                  </b>
                </td>
              </tr>
            </table>
    
            <table *ngIf="pagos_clientes.length == 0 && !!venta" style="overflow: wrap">
              <tr>
                <td><b>Relación pagos</b></td>
                <td colspan="5" class="text-right">
                  Total venta MXN: {{ venta.total_venta | currency }}
                  <small>{{ venta.clave_divisa }}</small>
                </td>
              </tr>
            
             <!--
              <tr>
                <td colspan="6"><hr /></td>
              </tr> -->
    
              <tr class="text-right">
                <td colspan="3">Total pago:</td>
                <td colspan="2" class="text-left">
                  <p>
                    {{ venta.pagado_cliente | currency }}
                    {{ venta.clave_divisa }}
                  </p>
                </td>
                <td *ngIf="venta.total_venta - venta.pagado_cliente == 0">
                  <b>Pagado</b>
                </td>
                <td *ngIf="venta.total_venta - venta.pagado_cliente > 0">
                  Total Saldo:
                  <b>
                    {{ venta.total_venta - venta.pagado_cliente | currency }}
                  </b>
                </td>
              </tr>
            </table>
    
            <!-- pasajeros -->
            <table *ngIf="lista_pasajeros.length > 0" style="overflow: wrap">
              <tr>
                <td><b>PASAJEROS</b></td>
              </tr>
              <tr [hidden]="!item.pasajero" *ngFor="let item of lista_pasajeros">
                <td *ngIf="!!item.pasajero">
                  {{ item.pasajero.paterno }} {{ item.pasajero.materno }} /
                  {{ item.pasajero.nombre }}
                </td>
              </tr>
            </table>
    
            <table style="overflow: wrap">
              <tr>
                <td class="text-center"><b>MXN = Peso Mexicano</b></td>
              </tr>
            </table>
            <!-- registro y facebook -->
          </div>
        </div>
        <div class="pdf_footer pdf_footer_balance">
          <table>
            <tr class="border-bottom">
              <td>Registro Nacional de Turismo: 04110200572</td>
              <td class="text-right">
                <i
                  aria-hidden="true"
                  class="fa fa-facebook fa-lg text-light bg-primary p-1 rounded"
                ></i>
                TADEO Viajes y Turismo
              </td>
            </tr>
          </table>
          <div class="pdf_footer">
            <p>
              Términos y condiciones Aéreos-información para el pasajero.- Los
              pasajeros deberán presentarse al registro de la documentación 2
              horas antes en vuelo nacional y 3 horas antes en vuelo
              internacional, después de ese tiempo no serán aceptados para
              viajar. Los pasajeros deberán estar en la puerta de abordaje
              mínimo 40 minutos antes de la salida del vuelo. Los cambios
              solicitados a la reserva (fecha, ruta), se aplica un cargo por
              cambio y deberá ser mínimo 5 horas antes de la salida (horario
              local). Cambios de nombre no son permitidos. Boletos emitidos no
              hay cancelaciones, no hay reembolso, aplica cargo por
              cancelación 100%. Paquetes - Nota Importante.- Los pagos
              anticipos y/o totales son al tipo de cambio del día. El no
              recibir pagos en las fechas estipuladas será causa de la
              cancelación de la reserva. Los cambios solicitados a la reserva
              (fecha/ruta), se aplica un cargo por cambio y deberá ser mínimo
              25 días antes de la fecha de salida. Le recomendamos que cuente
              con toda su documentación en regla y las vacunas
              correspondientes para el ingreso al país de su destino (en caso
              de ser destino internacional). Servicios no utilizados / no
              show, son NO REEMBOLSABLES. Los cambio de nombre no son
              permitidos. Cruceros - Notas importantes.- No se hará ninguna
              devolución en caso de que el pasajero no se presente (no-show),
              interrumpa o cancele después de que se inicie el crucero. No se
              devolverán los cupones de viaje no utilizados. Si usted no está
              a bordo al menos una hora antes de la hora programada de la
              salida del barco, nosotros tendremos el derecho de asumir que
              usted no tiene intenciones de viajar, su reservación será
              entonces cancelada, los cargos del 100% por cancelación y no se
              hará ningún reembolso.
              <br />
              Hotel - información huésped.- En caso de reservar directamente
              con el hotel se garantiza con tarjeta de crédito (Huésped). Si
              se reserva con operador se pedirá pago total al confirmar y no
              es reembolsable. Aplica cargos por cambio. Políticas de
              cancelación sujetas a políticas del hotel. Si el huésped va a
              hacer entrada al hotel fuera de horario deberá avisar al hotel a
              fin de que le respeten su reserva y no aplique NO SHOW.
            </p>
          </div>
        </div>
      </div>
    
      <!-- ========== End pdf ========== -->
    </div>
  </div>
</div>
